// extracted by mini-css-extract-plugin
module.exports = {"filterSummary":"FilterSummary_filterSummary__1tq0o"};